module.exports = __webpack_public_path__ + "img/PS9.062a44c8.png";